// extracted by mini-css-extract-plugin
export default {"container":"Error-module_container_a3d749","link":"Error-module_link_a8dda5"};